import { createFileRoute } from '@tanstack/react-router'

import { TenantFeaturesPage } from '@/pages/tenants/detail/TenantFeaturesPage'

export const Route = createFileRoute('/_authenticated/tenants/$id/features')({
  component: TenantFeaturesPage,
})
